import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createDomainApi, domainApiRelativePath } from './index';
import { createFakeGetResponder, createFakePutResponder, } from './../../../test-utils';
export var createDomainApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createDomainApi('', fakeHttp);
    var testKit = {
        whenGetDomainSettings: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + domainApiRelativePath + (brandId ? "?brandId=" + brandId : ''));
        },
        whenLinkDomain: function (dto) {
            return createFakePutResponder(fakeHttp, domainApiRelativePath + "/connect")(dto);
        },
        whenUnlinkDomain: function (brandId) {
            return createFakePutResponder(fakeHttp, domainApiRelativePath + "/disconnect")({ brandId: brandId });
        },
        whenCheckDomainStatus: function (domain) {
            return createFakeGetResponder(fakeHttp, domainApiRelativePath + "/check?domain=" + domain);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map